module.exports = __webpack_public_path__ + "static/media/UniNeueHeavy-Italic.0309324b.woff2";